export const INITIAL_COLOR = '#fff'
export const PREDEFINE_COLORS = [
  '#001f3f',
  '#0074d9',
  '#7fdbff',
  '#39cccc',
  '#3d9970',
  '#2ecc40',
  '#01ff70',
  '#ffdc00',
  '#ff851b',
  '#ff4136',
  '#f012be',
  '#b10dc9',
  '#85144b',
  '#ffffff',
  '#dddddd',
  '#aaaaaa',
  '#111111'
]
